var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.rows)?_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"search-options":{
      enabled: true,
      skipDiacritics: true,
    },"sort-options":{
      enabled: false,
    },"pagination-options":{
      enabled: true,
      perPage: 30,
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }